import React from "react";
import "./ContactUs.scss";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaPhone, FaMapMarkerAlt } from "react-icons/fa";


const ContactUs = () => {
  return (
    // <div className="container-fluid login" id="about">
    //   <div class="grid gap-3">
    //     <h1>
    //       <a
    //         href="#"
    //         class="link-body-emphasis link-offset-2 link-underline-opacity-25 link-underline-opacity-75-hover"
    //       >
    //         Contact Us
    //       </a>
    //     </h1>
    //     <div class="p-1 g-col-6">
    //       <i
    //         class="fa fa-phone "
    //         style={{ marginRight: "10px" }}
    //         aria-hidden="true"
    //       ></i>
    //       9037984531
    //     </div>
    //     <div class="p-1 g-col-6">
    //       <i
    //         class="fa fa-phone"
    //         style={{ marginRight: "10px" }}
    //         aria-hidden="true"
    //       ></i>
    //       9037984532
    //     </div>
    //     <div class="p-1 g-col-6">
    //       <i
    //         class="fa fa-phone"
    //         style={{ marginRight: "10px" }}
    //         aria-hidden="true"
    //       ></i>
    //       9037984533
    //     </div>
    //   </div>

    //   <form>
    //     <h1>
    //       <a
    //         href="#"
    //         class="link-body-emphasis link-offset-2 link-underline-opacity-25 link-underline-opacity-75-hover"
    //       >
    //         Address
    //       </a>
    //     </h1>
    //     <div class="p-1 g-col-6">Springway</div>
    //     <div class="p-1 g-col-6">
    //       <i class="fa fa-map-marker" aria-hidden="true"></i>VIJAYA TOWER
    //     </div>
    //     <div class="p-1 g-col-6">MEVARAM (NH 66)</div>
    //     <div class="p-1 g-col-6">KOLLAM PIN 691020</div>


    //     <div class="p-1 g-col-6">Springway Home care</div>
    //     <div class="p-1 g-col-6">
    //       <i class="fa fa-map-marker" aria-hidden="true"></i> Pakalkuri Pallickal (po)
    //     </div>
    //     <div class="p-1 g-col-6">TVM Pin (695604)</div>

    //     <div class="p-1 g-col-6">Springway Vegetable Garden</div>
    //     <div class="p-1 g-col-6">
    //       <i class="fa fa-map-marker" aria-hidden="true"></i>   Pakalkuri Pallickal (Po)TVM
    //     </div>
    //     <div class="p-1 g-col-6">  Pin (695604)</div>




    //     <div class="p-1 g-col-6">Springway Garden</div>
    //     <div class="p-1 g-col-6">
    //       <i class="fa fa-map-marker" aria-hidden="true"></i>Pakalkuri Pallickal (Po)TVM
    //     </div>
    //     <div class="p-1 g-col-6">Pin (695604)</div>
    //     <div class="p-1 g-col-6">Sub Unit</div>
    //     <div class="p-1 g-col-6">Spw</div>
    //     <div class="p-1 g-col-6">Vellanad Tvm Pin (695542)</div>

    //   <div class="p-1 g-col-6">Springway</div>
    //     <div class="p-1 g-col-6">
    //       <i class="fa fa-map-marker" aria-hidden="true"></i>VIJAYA TOWER
    //     </div>
    //     <div class="p-1 g-col-6">MEVARAM (NH 66)</div>
    //     <div class="p-1 g-col-6">KOLLAM PIN 691020</div>

    //   </form>
    // </div>
    
    <Container fluid className="p-4">
      <Row className="justify-content-center">
        <Col xs={12} md={10} lg={8}>
          <Card className="shadow-lg p-4 contact-bg">
            <h2 className="text-center mb-4">Contact Us</h2>
            <Row>
              <Col xs={12} md={4}>
                <Card className="p-3 text-center shadow-sm contact-bg">
                  <FaPhone size={20} className="text-primary" />
                  <p className="mt-2">9037984531</p>
                </Card>
              </Col>
              <Col xs={12} md={4}>
                <Card className="p-3 text-center shadow-sm contact-bg">
                  <FaPhone size={20} className="text-primary" />
                  <p className="mt-2">9037984532</p>
                </Card>
              </Col>
              <Col xs={12} md={4}>
                <Card className="p-3 text-center shadow-sm contact-bg">
                  <FaPhone size={20} className="text-primary" />
                  <p className="mt-2">9037984533</p>
                </Card>
              </Col>
            </Row>

            {/* <h3 className="mt-4">Address</h3> */}
            <Card className="p-3 shadow-sm contact-bg">
              <p><FaMapMarkerAlt className="text-danger" /> Springway</p>
              <p>📍 VIJAYA TOWER, MEVARAM (NH 66), KOLLAM PIN 691020</p>
            </Card>
            <Card className="p-3 shadow-sm mt-3 contact-bg">
              <p><FaMapMarkerAlt className="text-danger" /> Springway Home Care</p>
              <p>📍 Pakalkuri Pallickal (po), TVM Pin (695604)</p>
            </Card>
            <Card className="p-3 shadow-sm mt-3 contact-bg">
              <p><FaMapMarkerAlt className="text-danger" /> Springway Vegetable Garden</p>
              <p>📍 Pakalkuri Pallickal (Po) TVM, Pin (695604)</p>
            </Card>
            <Card className="p-3 shadow-sm mt-3 contact-bg">
              <p><FaMapMarkerAlt className="text-danger" />Springway Garden</p>
              <p>📍 Pakalkuri Pallickal (Po) TVM, Pin (695604)</p>
              <p>Sub Unit Spw Vellanad Tvm Pin (695542)</p>
            </Card>
          </Card>
        </Col>
      </Row>
    </Container>
  );


};

export default ContactUs;
